import React from 'react';
import { FileText, ExternalLink } from 'lucide-react';
import { Badge } from '../ui/badge';

interface Document {
  name: string;
  url: string;
}

interface DocumentsListProps {
  documents: Document[];
  className?: string;
}

const DocumentsList: React.FC<DocumentsListProps> = ({ documents, className = '' }) => {
  if (!documents || documents.length === 0) {
    return null;
  }

  // Remove duplicates based on document name and URL
  const uniqueDocuments = documents.filter((doc, index, self) => 
    index === self.findIndex(d => d.name === doc.name && d.url === doc.url)
  );

  return (
    <div className={`mt-4 ${className}`}>
      <div className="flex items-center gap-2 mb-3">
        <FileText className="w-4 h-4 text-blue-600" />
        <h4 className="text-sm font-medium text-gray-700">
          Hồ sơ đính kèm ({uniqueDocuments.length})
        </h4>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {uniqueDocuments.map((document, index) => (
          <Badge
            key={`${document.name}-${index}`}
            variant="secondary"
            className="h-12 px-4 py-2 text-base cursor-pointer bg-blue-50 border border-blue-200 shadow-sm hover:bg-blue-100 hover:text-blue-800 hover:shadow-md hover:scale-105 focus:ring-2 focus:ring-blue-300 focus:outline-none transition-all duration-200"
            onClick={() => {
              if (document.url) {
                window.open(document.url, '_blank', 'noopener,noreferrer');
              }
            }}
            title={`Mở hồ sơ: ${document.name}`}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if ((e.key === 'Enter' || e.key === ' ') && document.url) {
                e.preventDefault();
                window.open(document.url, '_blank', 'noopener,noreferrer');
              }
            }}
          >
            <FileText className="w-5 h-5 mr-2 flex-shrink-0" />
            <span className="truncate flex-1">{document.name}</span>
            <ExternalLink className="w-4 h-4 ml-2 flex-shrink-0 opacity-60" />
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default DocumentsList;